module.exports = __webpack_public_path__ + "img/shield.7f459700.svg";